import { RecompArgument } from '@/api/reload/RecompArgument';

export class ReloadDataTableEntry {
  public id: string;

  public fiId: number | null;

  public reloadPoint: string;

  public dateRange: String;

  public startDate: Date;

  public endDate: Date;

  public initiated: Date;

  public userName: string;

  public reason: string;

  public status: string;

  public cancelExistingReloads: boolean;

  public details: string;

  public skipRewardsProcessing: boolean;

  public includesRecomp: boolean;

  public recompArgumentList: RecompArgument[];

  public sortableStartDate: number | null;

  public friendlyInitiated: string;

  public sortableInitiated: number | null;

  public friendlyTime: string;

  public friendlyReason: string | undefined;

  public friendlyStatus: string | undefined;

  public friendlySkipRewardsProcessing: string;

  constructor() {
    this.id = '';
    this.fiId = 0;
    this.reloadPoint = '';
    this.dateRange = '';
    this.startDate = new Date();
    this.endDate = new Date();
    this.initiated = new Date();
    this.userName = '';
    this.reason = '';
    this.status = '';
    this.cancelExistingReloads = false;
    this.details = '';
    this.skipRewardsProcessing = false;
    this.includesRecomp = false;
    this.recompArgumentList = [];
    this.sortableStartDate = 0;
    this.friendlyInitiated = '';
    this.sortableInitiated = 0;
    this.friendlyTime = '';
    this.friendlyReason = '';
    this.friendlyStatus = '';
    this.friendlySkipRewardsProcessing = '';
  }
}

export default ReloadDataTableEntry;
